export const ADD_TO_BLOG = 'ADD_TO_BLOG';
export const ERROR = 'ERROR';
export const FETCH_TITLES = 'FETCH_TITLES';
export const FETCH_POST = 'FETCH_POST';
export const ADD_POST = 'ADD_POST';
export const REMOVE_POST = 'REMOVE_POST';
export const ADD_COMMENT = 'ADD_COMMENT';
export const REMOVE_COMMENT = 'REMOVE_COMMENT';
export const VOTE = 'VOTE';
